export const DateFormat = {
  MONTH_DAY_YEAR: 'MMM dd, yyyy',
  MONTH_DAY_YEAR_WITHOUT_COMA: 'MMM dd yyyy',
  HOURS_AM_PM: 'hh:mm, aaa',
  YEAR_MONTH_DAY_DASH: 'yyyy-MM-dd',
  YEAR_MONTH_DAY_DASH_WITH_TIME: "yyyy-MM-dd'T'HH:mm:ss",
} as const;
